import type { Router } from 'next/router';

interface Params {
  query: Router['query'];
  queryKeysToClear: string[];
}

const sanitizeFiltersFromRouterQuery = ({ query, queryKeysToClear }: Params) =>
  Object.keys(query).reduce((sanitizedQuery, key) => {
    if (!queryKeysToClear.includes(key)) {
      sanitizedQuery[key] = query[key];
    }
    return sanitizedQuery;
  }, {} as typeof query);

export default sanitizeFiltersFromRouterQuery;
